import React, { Component } from 'react';

import ItemCollectionBase from '../Components/ItemCollectionBase';

import { SupportCompanies_Collection } from '../Model/SupportCompanies';

class SupportCompanies extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

    this.Collection = new SupportCompanies_Collection(
      props,
      () => {},
      () => {},
    );
  }

  render() {
    return (
      <ItemCollectionBase
        {...this.props}

        pageTitle="Support: Companies"
        contentUri={this.Collection.ContentUri}
        contentUriParams={this.Collection.ContentUriParams}
        collectionName={this.Collection.CollectionName}
        itemsName={this.Collection.ItemsName}
        itemName={this.Collection.ItemName}
        defaultViewType={this.Collection.DefaultViewType}
        
        onGetCollectionFieldsPromise={this.Collection.HandleGetCollectionFieldsPromise}
        onGetHeadCells={this.Collection.HandleGetHeadCells}
        onGetCardGridItems={this.Collection.HandleGetCardGridItems}
        onGetTableRows={this.Collection.HandleGetTableRows}

        loadItemsImmediately
        hideFilterSortDrawer
      />
    );
  }
}

export default SupportCompanies;